import axios from 'axios';
import { message } from 'antd';

export const apiClient = axios.create({
  baseURL: '/api/v1',
  withCredentials: true,
  headers: {},
});

// 本地计算专用：直连 localhost:8000
export const localApiClient = axios.create({
  baseURL: 'http://localhost:8000/api/v1',
  withCredentials: true,
  timeout: 600000,
});

apiClient.interceptors.request.use(
  (config) => config,
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const status = error.response.status;
      if (status === 401) {
        window.location.href = '/login';
      } else if (status >= 500) {
        message.error('服务器内部错误，请稍后重试');
      }
    }
    return Promise.reject(error);
  }
);
